
// import { InvoiceableRepository } from "@/modules/facturae/domain/InvoiceableRepository"
import { async_command_dispatcher } from "@/api/client";

export class DownloadEInvoicesExcelCommand {
    constructor(
        // private readonly invoices_provider : InvoiceableRepository,
        private screen_data
    ) {}

    async run(ids: Array<number>) {
        // this.screen_data.loadingExcelDownload = true
        let args = {invoice_ids: ids}
        let resOutput
        try {
            resOutput = await async_command_dispatcher.dispatch_with_result('download.facturae.excel', args, 1000)    
        } catch (error) {
            console.error('Error getting file download url', error)
            resOutput = null
        }
        console.log(typeof resOutput)
        // this.screen_data.loadingExcelDownload = false
        return resOutput
    }
}